import PropTypes from "prop-types";
import React, { useCallback } from "react";
import Swal from "sweetalert2";

import { useGetCreditsAvailableQuery } from "../../../../features/api/payments";
import useCloneBom from "../../../../hooks/useCloneBom";
import useQualifyBOM from "../../../../hooks/useQualifyBOM";
import bomDetail from "../../../../propTypes/bomDetail";
import { CONTINUE_ACTION_TYPE, REAPPLY_ACTION_TYPE } from "./constants";

function ActionButton({ name, actionType, bom }) {
  const { qualify } = useQualifyBOM(bom?.BOMID);
  const { handleClone } = useCloneBom();
  const { data: creditsAvailable } = useGetCreditsAvailableQuery();

  let disabled = true;
  if (creditsAvailable?.qualCredits && creditsAvailable.qualCredits > 0) {
    disabled = false;
  }
  const handleClick = useCallback(() => {
    if (disabled) {
      Swal.fire({
        icon: "error",
        title: "Not enough credits",
        text: "You don't have enough qualification credits to perform this action. Please purchase more credits to continue.",
        confirmButtonText: "Upgrade Now",
        showDenyButton: true,
        denyButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = `${import.meta.env.VITE_MAIN_SITE_URL}/dashboard/upgrade/products/usmca`;
        }
      });
    } else if (actionType === CONTINUE_ACTION_TYPE) {
      qualify();
    } else if (actionType === REAPPLY_ACTION_TYPE) {
      handleClone(bom);
    }
  }, [actionType, qualify, bom, handleClone, disabled]);

  return (
    <button onClick={handleClick} type="button" className="btn btn-outline-primary fw-bold">
      {name}
    </button>
  );
}

ActionButton.propTypes = {
  name: PropTypes.string.isRequired,
  actionType: PropTypes.oneOf([CONTINUE_ACTION_TYPE, REAPPLY_ACTION_TYPE]).isRequired,
  bom: bomDetail.isRequired,
};

export default ActionButton;
